/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import Budget from "models/Budget";
import StayType from "models/StayType";
import Transport from "models/Transport";
import Duration from "models/Duration";
import Country from "models/Country";

export interface MapsSlice {
  modalCountry: Country;
  loading: boolean;
  open: boolean;
}

const initialState: MapsSlice = {
  modalCountry: null,
  loading: false,
  open: false,
};

const globalReducer = createSlice({
  name: "global",
  initialState,
  reducers: {
    LOAD_COUNTRY: (state, action) => {
      state.loading = true;
    },
    LOAD_COUNTRY_SUCCESS: (state, action) => {
      state.loading = false;
      state.open = true;
      state.modalCountry = action.payload;
    },
    CLOSE_MODAL: (state) => {
      state.open = false;
    },
  },
});

export const { LOAD_COUNTRY, LOAD_COUNTRY_SUCCESS, CLOSE_MODAL } =
  globalReducer.actions;

export default globalReducer.reducer;
